import axios from 'axios';
import qs from 'qs';

import authInteceptor from './authInterceptor';
import tokenInterceptor from './tokenInterceptor';

const { VUE_APP_BASE_URL } = process.env;
const namespace = 'api/ocean';
const version = 'v1';

export default () => {
  axios.defaults.paramsSerializer = params => qs.stringify(params, { arrayFormat: 'brackets' });
  axios.defaults.baseURL = `${VUE_APP_BASE_URL}/${namespace}/${version}`;
  axios.interceptors.response.use(response => response, authInteceptor);
  axios.interceptors.request.use(tokenInterceptor, err => Promise.reject(err));
};
